/** Tiny platform sniffs used for OS-specific deep links. */

/**
 * Detect iOS / iPadOS. Modern iPads report as "MacIntel" with touch, so we
 * also check for a touch-capable Mac.
 */
export function isIOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}
